export const SLIDER_CONTENT = [
    {
        image: require('../../Assets/img/man.png'),
        paragraph:
            "Lorem Ipsum is simply dummy text of the printing and typesettingindustry. Lorem Ipsum has been the industry's standard dummy text eversince the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
        firstname: "Abhishek",
        lastname: "Tiwari",
        designation: "Head - Product & Strategy",
    },
    {
        image: require('../../Assets/img/man.png'),
        paragraph: "I love gaming arcade.",
        firstname: "Naveen",
        lastname: "Aggarwal",
        designation: "CTO",
    },
];